import { createFileRoute } from "@tanstack/react-router";
import { ProviderProfilePage } from "@/features/profile/components/ProviderProfilePage";
import { useProviderUser } from "@/hooks/useProviderUser";
import { useProviderProfileData } from "@/features/profile/hooks/useProviderProfileData";
import Loading from "@/components/Loading";

const ProviderPersonalPage = () => {
  const providerUser = useProviderUser();
  const { data, isLoading, error } = useProviderProfileData(providerUser.id);

  if (isLoading || !data) {
    return (
      <div className="flex items-center justify-center min-h-[50vh]">
        <Loading className="h-16 w-16" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center min-h-[50vh]">
        <div className="text-center text-red-600">
          Unable to load profile. Please try again.
        </div>
      </div>
    );
  }

  return (
    <ProviderProfilePage
      user={providerUser}
      credentials={data.credentials}
      jobPreferences={data.jobPreferences}
      sharePermissions={data.sharePermissions}
      isMe={true}
    />
  );
};

export const Route = createFileRoute("/_provider/provider/profile/")({
  component: ProviderPersonalPage,
});
